import FqApi from '@/services/fq-api'
import { BYTES_PER_MB } from '@/services/byteUnits'

/**
 * PCK-213 - per-file upload caps, read from the API instead of hardcoded.
 *
 * The same 10MB was written into every uploader in both apps, with nothing keeping the copies in
 * step. A shared JS constant cannot fix it because apps/web and apps/pwa are separate builds, so
 * the setting is the only single source both can read - apps/pwa has its own copy of this module.
 *
 * Memoised: the caps do not change within a page load.
 */

export const FALLBACK_MAX_FILE_BYTES = 10 * BYTES_PER_MB
export const FALLBACK_AUDANET_MAX_FILE_BYTES = 1.5 * BYTES_PER_MB

const FALLBACK = Object.freeze({
  maxFileBytes: FALLBACK_MAX_FILE_BYTES,
  audaNetMaxFileBytes: FALLBACK_AUDANET_MAX_FILE_BYTES
})

let cached = null

export function getUploadLimits() {
  if (!cached) {
    cached = FqApi.get('/settings/uploadlimits')
      .then((response) => {
        const data = (response && response.data) || {}
        const maxFileBytes = Number(data.maxFileBytes)
        const audaNetMaxFileBytes = Number(data.audaNetMaxFileBytes)
        return {
          maxFileBytes: Number.isFinite(maxFileBytes) && maxFileBytes > 0 ? maxFileBytes : FALLBACK.maxFileBytes,
          audaNetMaxFileBytes:
            Number.isFinite(audaNetMaxFileBytes) && audaNetMaxFileBytes > 0
              ? audaNetMaxFileBytes
              : FALLBACK.audaNetMaxFileBytes
        }
      })
      .catch(() => FALLBACK)
  }
  return cached
}

/** Dropzone's maxFilesize option is in MB. */
export async function getMaxUploadFileMb() {
  const limits = await getUploadLimits()
  return limits.maxFileBytes / BYTES_PER_MB
}

export async function getAudaNetMaxFileMb() {
  const limits = await getUploadLimits()
  return limits.audaNetMaxFileBytes / BYTES_PER_MB
}

/** Test seam - drops the memoised result so each spec starts clean. */
export function resetUploadLimitsCache() {
  cached = null
}

export default { getUploadLimits, getMaxUploadFileMb, getAudaNetMaxFileMb, resetUploadLimitsCache }
